import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  VERIFY_COGNITO_USER,
  CREATE_COGNITO_USER,
  ACCEPT_OTP
} from "constants/ActionTypes";
import { SIGN_IN_COGNITO_USER, VERIFY_COGNITO_OTP, PUT_COGNITO_USER, INIT_COGNITO_AUTH_SESSION, SIGN_IN_COGNITO_USER_SUCCESS, SIGNUP_COGNIO_USER_SUCCESS, RESET_AUTH_STORE, SHOW_AUTH_MESSAGE } from "../../constants/ActionTypes";
import { identify } from "../../analytics";

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: null,
};
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_COGNITO_AUTH_SESSION: {
      identify(action.payload)
      return {
        ...state,
        authUser : action.payload,
        sessionInitComplete:true,
        loader:false
      }
    }
    case RESET_AUTH_STORE: {
      return {
        loader:false.payload,
        authUser:null,
        cognitoUser:null
      }
    }
    case CREATE_COGNITO_USER: {
      return {
        ...state,
        loader: false,
        // showOTP: true,
        userDetails: action.payload,
      }
    }
    case SIGN_IN_COGNITO_USER: {
      return {
        ...state,
        loader: false,
        // showOTP: true,
        cognitoUser: action.payload
      }
    }
    case VERIFY_COGNITO_USER: {
      return {
        ...state,
        loader: false,
        // showOTP: false,
        // cognitoUser: action.payload
      }
    }
    case VERIFY_COGNITO_OTP: {
      return {
        ...state,
        loader: false,
        showOTP: true,
        cognitoUser: action.payload
      }
    }
    case SIGN_IN_COGNITO_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        showOTP: false,
        cognitoUser:null,
        authUser: action.payload
      }
    }
    case SIGNUP_COGNIO_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        showOTP: false,
        cognitoUser:null,
        authUser: action.payload
      }
    }
    case PUT_COGNITO_USER: {
      return {
        ...state,
        cognitoUser: action.payload
      }
    }
    case ACCEPT_OTP: {
      return {
        ...state,
        loader: false,
        showOTP:true,
      }
    }
    case SIGNUP_USER_SUCCESS: {
      identify(action.payload)
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        initURL: '/',
        loader: false,
        showOTP:false
      }
    }

    case SHOW_AUTH_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    case SIGNIN_GOOGLE_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_FACEBOOK_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_TWITTER_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_GITHUB_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    default:
      return state;
  }
}
